import React, { useState, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBars, faTachometerAlt, faBox, faUsers, faTags, faKey,
    faFileAlt, faClipboardList, faWarehouse, faEnvelope, faSignOutAlt,faCalendarAlt,faNetworkWired
} from '@fortawesome/free-solid-svg-icons';
import Users from './Users';
import Categories from './Categories';
import Products from './Products';
import Permissions from './Permissions';
import AdminReports from './AdminReports';
import ReportDetails from './ReportDetails';
import Dashboard from './Dashboard';
import Orders from './Orders';
import InventoryCheck from './InventoryCheck';
import Inbox from './Inbox';
import SendMessage from './SendMessage';
import { jwtDecode } from 'jwt-decode';
import CalendarView from './CalendarView';
import CalendarAdmin from './CalendarAdmin';
import NmapX from './NmapX'; // Import NmapX
import '../css/AdminPage.css';

const AdminPage = () => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [showSidebar, setShowSidebar] = useState(true); // State for sidebar visibility on mobile
    const navigate = useNavigate();
    const [view, setView] = useState('dashboard');
    const [users, setUsers] = useState([
        { id: 1, name: 'User1', permissions: { add: true, delete: true, update: true } },
        { id: 2, name: 'User2', permissions: { add: false, delete: false, update: false } },
    ]);
    const [totalWeeklyHours, setTotalWeeklyHours] = useState(0);

    const updateUserPermissions = (userId, newPermissions) => {
        setUsers(users.map(user => user.id === userId ? { ...user, permissions: newPermissions } : user));
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const decodedToken = jwtDecode(token);
            const role = decodedToken.sub?.role || decodedToken.role;
            setIsAdmin(role === 'admin');
        }
    }, []);

    // Helper function to handle sidebar item clicks on mobile
    const handleSidebarItemClick = (selectedView) => {
        setView(selectedView);
        // Close the sidebar on mobile
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="admin-dashboard">
            {/* Toggle Button for Sidebar on mobile */}
            <button 
                className="toggle-sidebar" 
                onClick={() => setShowSidebar(!showSidebar)}
                aria-label="Toggle Sidebar"
            >
                <FontAwesomeIcon icon={faBars} />
            </button>

            {/* Sidebar */}
            <div className={`sidebar ${showSidebar ? '' : 'hidden'}`}>
                <h2>ProdoCo</h2>
                <ul className="sidebar-menu">
                    <li onClick={() => handleSidebarItemClick('dashboard')}>
                        <FontAwesomeIcon icon={faTachometerAlt} /> Dashboard
                    </li>
                    <li onClick={() => handleSidebarItemClick('products')}>
                        <FontAwesomeIcon icon={faBox} /> Products
                    </li>
                    <li onClick={() => handleSidebarItemClick('users')}>
                        <FontAwesomeIcon icon={faUsers} /> Users
                    </li>
                    <li onClick={() => handleSidebarItemClick('categories')}>
                        <FontAwesomeIcon icon={faTags} /> Categories
                    </li>
                    <li onClick={() => handleSidebarItemClick('permissions')}>
                        <FontAwesomeIcon icon={faKey} /> Permissions
                    </li>
                    <li onClick={() => handleSidebarItemClick('reports')}>
                        <FontAwesomeIcon icon={faFileAlt} /> Reports
                    </li>
                    <li onClick={() => handleSidebarItemClick('orders')}>
                        <FontAwesomeIcon icon={faClipboardList} /> Orders
                    </li>
                    <li onClick={() => handleSidebarItemClick('inventory')}>
                        <FontAwesomeIcon icon={faWarehouse} /> Inventory Check
                    </li>
                    <li onClick={() => handleSidebarItemClick('messages')}>
                        <FontAwesomeIcon icon={faEnvelope} /> Messages
                    </li>
                    <li onClick={handleLogout}>
                        <FontAwesomeIcon icon={faSignOutAlt} /> Logout
                    </li>
                    <li onClick={() => handleSidebarItemClick('calendar')}>
                        <FontAwesomeIcon icon={faCalendarAlt} /> Calendar
                    </li>
                    <li onClick={() => setView('nmap_x')}>
                        <FontAwesomeIcon icon={faNetworkWired} /> NMAP_X
                    </li>
                </ul>
            </div>

            {/* Main Content */}
            <div className="main-content">
                {view === 'dashboard' && <Dashboard />}
                {view === 'products' && <Products users={users} />}
                {view === 'users' && <Users />}
                {view === 'categories' && <Categories />}
                {view === 'permissions' && (
                    <Permissions users={users} updateUserPermissions={updateUserPermissions} />
                )}
                {view === 'reports' && <AdminReports />}

                <Routes>
                    <Route path="report/:id" element={<ReportDetails />} />
                </Routes>
             
                {view === 'orders' && <Orders isAdmin={isAdmin} />}
                {view === 'inventory' && <InventoryCheck />}
                {view === 'messages' && (
                    <div>
                        <Inbox />
                        <SendMessage />
                    </div>
                )}

{view === 'calendar' && (
                    <div>
                        <CalendarView />
                        {isAdmin && <CalendarAdmin />}
                    </div>
                )}

{view === 'nmap_x' && <NmapX />}
                
            </div>
        </div>
    );
};

export default AdminPage;
